
import EnCustomer from "../images/en/customer.png"



import { UserLogoMapType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapType = {

    en: EnCustomer,
    em: EnCustomer,


};
